import React, { useState, useEffect } from 'react'
import { ValidationForm } from '../../../../_components/Forms/ValidationForm'

export const FeeForm = ({
  entity,
  submitHandler,
  onChange,
  onBlur,
  getFormFunctions,
  onErrorsUpdate,
  setDisplayedFields,
  getErrors,
}) => {
  const [allowEnd, setAllowEnd] = useState(entity.has_range_end === 'true')
  //Trying to avoid registration issues  with react hook form by returning a whole component instead of just fields
  const termFields = [
    {
      id: 'name',
      label: 'What is the name of this term?',
      type: 'text',
    },
    // TODO: Add entity when available in the back end
    // {
    //     id: 'entity',
    //     label: 'What is this fee based on?',
    //     type: 'select',
    //     options: [
    //         {
    //             value: 1,
    //             display: 'Face Value',
    //         },
    //         {
    //             value: 0,
    //             display: 'Flat Fee',
    //         },
    //         {
    //             value: 2,
    //             display: 'Advance Amount',
    //         },
    //         {
    //             value: 3,
    //             display: 'Remaining Amount',
    //         },
    //     ],
    // },

    {
      id: 'type',
      label: (
        <div>
          What type of rate is this?
          <br />
          <ul>
            <li>Age range fees are used to charge a rate between invoice ages.</li>
            <li>Daily rates charge a percent against invoices every day.</li>
            <li>Every X Day rates are charged each time the time frame selected passes.</li>
            <li>One time fees are charged once.</li>
          </ul>
        </div>
      ),
      type: 'select',
      options: [
        {
          value: 'FeeAgeRange',
          display: 'Age Range',
        },
        {
          value: 'FeeRecurring',
          display: 'Daily Rate',
        },
        {
          value: 'FeeTiered',
          display: 'Every X Day',
        },
        {
          value: 'FeeOneTime',
          display: 'One Time',
        },
      ],
      required: false,
      disabled: !!entity.id,
    },
  ]

  // FeeAgeRange
  const termTieredFields = [
    {
      id: 'entity',
      label: 'Charge fee on?',
      type: 'select',
      options: [
        {
          value: 1,
          display: 'Invoice Amount',
        },
        {
          value: 2,
          display: 'Advanced Amount',
        },
      ],
      className: 'table-field',
      validate: (value) => {
        return null
      },
      required: false,
      disabled: !!entity.id,
    },
    {
      id: 'range_based_on',
      label: 'Base the fee age on?',
      type: 'select',
      options: [
        {
          value: 0,
          display: 'Purchase Date',
        },
        {
          value: 1,
          display: 'Invoice Date',
        },
      ],
      className: 'table-field',
      validate: (value) => {
        return null
      },
      required: false,
      disabled: !!entity.id,
    },
    {
      id: 'value',
      label: 'How much do you want to charge?',
      type: 'percent',
      fixedLength: 3,
      className: 'table-field',
      validate: (value) => {
        return null
      },
    },
    {
      id: 'range_begin',
      label: 'What day does this rate start to charge?',
      type: 'number',
      className: 'table-field',
      validate: (value) => {
        if (value < 1) {
          return 'Day must be greater than or equal to 1.'
        }
        return null
      },
    },
    {
      id: 'range_end',
      label: 'What day does this rate end?',
      type: 'number',
      className: 'table-field',
      key: allowEnd + 'range_end',
      explainer: (
        <div style={{ display: 'block', textAlign: 'left' }}>
          <span>Once the age exceeds an end date the fee is no longer accrued or earned.</span>
          <br />
          <br />
          <span>
            Example: A start day of 1 and end day of 10. If the invoice ages to day 11 the fee would no longer be
            accrued or earned. If the invoice ages to day 8 the fee would be accrued or earned.
          </span>
        </div>
      ),
      validate: (value) => {
        return null
      },
    },
  ]

  // FeeTiered
  const termXDaysFields = [
    {
      id: 'entity',
      label: 'Charge fee on?',
      type: 'select',
      options: [
        {
          value: 1,
          display: 'Invoice Amount',
        },
        {
          value: 2,
          display: 'Advanced Amount',
        },
      ],
      className: 'table-field',
      validate: (value) => {
        return null
      },
      required: false,
      disabled: !!entity.id,
    },
    {
      id: 'range_based_on',
      label: 'Base the fee age on?',
      type: 'select',
      options: [
        {
          value: 0,
          display: 'Purchase Date',
        },
        {
          value: 1,
          display: 'Invoice Date',
        },
      ],
      className: 'table-field',
      validate: (value) => {
        return null
      },
      required: false,
      disabled: !!entity.id,
    },
    {
      id: 'range_begin',
      label: 'What day does this rate start to charge?',
      type: 'number',
      className: 'table-field',
      validate: (value) => {
        if (value < 1) {
          return 'Day must be greater than or equal to 1.'
        }
        return null
      },
    },
    {
      id: 'has_range_end',
      label: 'Does this rate have an end date?',
      type: 'select',
      options: [
        {
          value: 'true',
          display: 'Yes',
        },
        {
          value: 'false',
          display: 'No',
        },
      ],
      className: 'table-field',
      validate: (value) => {
        return null
      },
      required: false,
      disabled: !!entity.id,
    },
    {
      id: 'range_end',
      label: 'What day does this rate end?',
      type: 'number',
      className: 'table-field',
      key: allowEnd + 'range_end',
      required: allowEnd,
      validate: (value) => {
        return null
      },
      explainer: (
        <div style={{ display: 'block', textAlign: 'left' }}>
          <span>Once the age exceeds an end date the fee is no longer accrued or earned.</span>
          <br />
          <br />
          <span>
            Example: A start day of 1 and end day of 10. If the invoice ages to day 11 the fee would no longer be
            accrued or earned. If the invoice ages to day 8 the fee would be accrued or earned.
          </span>
        </div>
      ),
    },
    {
      id: 'range_increment',
      label: 'So Every X Days',
      type: 'number',
      className: 'table-field',
      validate: (value) => {
        return null
      },
    },
    {
      id: 'value',
      type: 'percent',
      label: 'The rate increases by ',
      fixedLength: 2,
      className: 'table-field',
      validate: (value) => {
        return null
      },
    },
  ]

  // FeeOneTime
  const termOneTimeFields = [
    {
      id: 'entity',
      label: 'Charge fee on?',
      type: 'select',
      options: [
        {
          value: 1,
          display: 'Invoice Amount',
        },
        {
          value: 2,
          display: 'Advanced Amount',
        },
      ],
      className: 'table-field',
      validate: (value) => {
        return null
      },
      required: false,
      disabled: !!entity.id,
    },
    {
      id: 'earn_event',
      label: 'When does the fee get charged?',
      type: 'select',
      options: [
        {
          value: 0,
          display: 'At time of invoice purchase.',
        },
        // {
        //     value: 1,
        //     display: 'When invoice is funded.',
        // },
        // {
        //     value: 2,
        //     display: 'When invoice is collected.',
        // },
        {
          value: 3,
          display: 'When invoice is closed.',
        },
      ],
      required: false,
    },
    {
      id: 'range_based_on',
      label: 'Base the fee age on?',
      type: 'select',
      options: [
        {
          value: 0,
          display: 'Purchase Date',
        },
        {
          value: 1,
          display: 'Invoice Date',
        },
      ],
      className: 'table-field',
      validate: (value) => {
        return null
      },
      required: false,
      disabled: !!entity.id,
    },
    {
      id: 'value',
      label: 'How much do you want to charge?',
      type: 'percent',
      className: 'table-field',
      fixedLength: 3,
      validate: (value) => {
        return null
      },
    },
    {
      id: 'range_begin',
      label: 'What day does this rate get charged?',
      type: 'number',
      className: 'table-field',
      validate: (value) => {
        return null
      },
    },
    // This will become relevant again at some point
    // {
    //     id: 'accrue_event', //TODO: Update the id of this to the real back-end parameter name when implemented.
    //     label: 'When does the fee accrue?',
    //     type: 'select',
    //     options: [
    //         {
    //             value: null,
    //             display: 'When the fee becomes active.',
    //         },
    //         {
    //             value: 0,
    //             display: 'At time of invoice purchase.',
    //         },
    //         {
    //             value: 1,
    //             display: 'When invoice is funded.',
    //         },
    //         {
    //             value: 2,
    //             display: 'When invoice is collected.',
    //         },
    //         {
    //             value: 3,
    //             display: 'When invoice is closed.',
    //         },
    //     ],
    // },
  ]

  // FeeRecurring
  const termRecurringFields = [
    {
      id: 'entity',
      label: 'Charge fee on?',
      type: 'select',
      options: [
        {
          value: 1,
          display: 'Invoice Amount',
        },
        {
          value: 2,
          display: 'Advanced Amount',
        },
      ],
      className: 'table-field',
      validate: (value) => {
        return null
      },
      required: false,
      disabled: !!entity.id,
    },
    {
      id: 'range_based_on',
      label: 'Base the fee age on?',
      type: 'select',
      options: [
        {
          value: 0,
          display: 'Purchase Date',
        },
        {
          value: 1,
          display: 'Invoice Date',
        },
      ],
      className: 'table-field',
      validate: (value) => {
        return null
      },
      required: false,
      disabled: !!entity.id,
    },
    {
      id: 'value',
      label: 'What is the annual rate?',
      type: 'percent',
      fixedLength: 2,
      className: 'table-field',
      validate: (value) => {
        return null
      },
    },
    {
      id: 'range_begin',
      label: 'What day does this rate start to charge?',
      type: 'number',
      className: 'table-field',
      validate: (value) => {
        if (value < 1) {
          return 'Day must be greater than or equal to 1.'
        }
        return null
      },
    },
    {
      id: 'has_range_end',
      label: 'Does this rate have an end date?',
      type: 'select',
      options: [
        {
          value: 'true',
          display: 'Yes',
        },
        {
          value: 'false',
          display: 'No',
        },
      ],
      defaultValue: 'false',
      className: 'table-field',
      validate: (value) => {
        return null
      },
      required: false,
      disabled: !!entity.id,
    },
    {
      id: 'range_end',
      label: 'What day does this rate end?',
      type: 'number',
      className: 'table-field',
      key: allowEnd + 'range_end',
      required: allowEnd,
      watchFieldName: 'has_range_end',
      watchFieldValue: 'true',
      validate: (value) => {
        return null
      },
      explainer: (
        <div style={{ display: 'block', textAlign: 'left' }}>
          <span>Once the age exceeds an end date the fee is no longer accrued or earned.</span>
          <br />
          <br />
          <span>
            Example: A start day of 1 and end day of 10. If the invoice ages to day 11 the fee would no longer be
            accrued or earned. If the invoice ages to day 8 the fee would be accrued or earned.
          </span>
        </div>
      ),
    },
    {
      id: 'days_in_year',
      label: 'Daily rate calculated at how many days per year?',
      type: 'select',
      options: [
        {
          value: '365',
          display: '365',
        },
        {
          value: '360',
          display: '360',
        },
      ],
      required: false,
      className: 'table-field',
    },
  ]

  const floatDaysFields = [
    {
      id: 'float_days',
      label: 'How many float days to add?',
      type: 'number',
      className: 'table-field',
      validate: (value) => {
        if (value < 0) {
          return 'Float days must be greater than or equal to 0.'
        }
        if (value % 1 !== 0) {
          return 'Float days must be a whole number.'
        }
        return null
      },
    },
    {
      id: 'float_type',
      label: 'Float days are based on?',
      type: 'select',
      options: [
        {
          value: 'calendar_days',
          display: 'Calendar days',
        },
        {
          value: 'week_days',
          display: 'Week days',
        },
      ],
      required: false,
      className: 'table-field',
    },
  ]

  const getFields = (fee) => {
    switch (fee.type) {
      case 'FeeAgeRange':
        return [...termFields, ...termTieredFields, ...floatDaysFields]
      case 'FeeTiered':
        return [
          ...termFields,
          ...(allowEnd ? termXDaysFields : termXDaysFields.filter((f) => f.id != 'range_end')),
          ...floatDaysFields,
        ]
      case 'FeeOneTime':
        return [
          ...termFields,
          ...(fee.earn_event !== 0
            ? termOneTimeFields
            : termOneTimeFields.filter((f) => f.id !== 'range_begin' && f.id !== 'range_based_on')),
        ]
      case 'FeeRecurring':
        return [
          ...termFields,
          ...(allowEnd ? termRecurringFields : termRecurringFields.filter((f) => f.id != 'range_end')),
          ...floatDaysFields,
        ]
    }
  }
  const [fields, setFields] = useState([])
  useEffect(() => {
    setFields(getFields(entity))
    setDisplayedFields(getFields(entity).map((f) => f.id))
  }, [
    entity.type,
    entity.entity,
    entity.has_range_end,
    entity.range_begin,
    entity.range_end,
    entity.earn_event,
    entity.float_days,
    entity.float_type,
    allowEnd,
  ])
  return (
    <ValidationForm
      entity={entity}
      fields={fields}
      getErrors={getErrors}
      getFormFunctions={getFormFunctions}
      key={'' + entity.type + ''}
      onBlur={onBlur}
      onChange={(id, newValue) => {
        if (id === 'has_range_end') {
          setAllowEnd(newValue === 'true')
        }
        onChange(id, newValue)
      }}
      onErrorsUpdate={onErrorsUpdate}
      submitHandler={submitHandler}
    />
  )
}
